import React from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import VideoList from "../components/VideoList";
import { utilLoopHelper } from "../utils";
import Footer from "../components/Footer";
import { pageFilter, getArtistCookie } from "../data/page_data";
import Loading from "../components/loading";
import CssLoader from "../components/CssLoader";
import { navigate } from "@reach/router";
import LoadingContent from "../components/loading-content";
import TrackVisibility from "react-on-screen";
import * as ReactGA from "react-ga";
import FloatingButton from "../components/FloatingButton";

class VideoPage extends React.Component {
  constructor(props) {
    super(props);
    this.pageData = pageFilter(this.props.artist, "../");
    this.state = {
      page: 2,
      title: "",
      items: [],
    };
    this.onload = false;
    this.finish = false;
  }

  componentDidMount() {
    axios
      .get("/w/api/" + this.pageData.artist.id + "/video?x=" + this.pageData.artist.exclusive)
      .then((response) => {
        var respData = response.data;
        this.setState((state) => ({
          page: 2,
          title: "Video " + this.pageData.artist.nick,
          items: respData.items,
        }));
      })
      .catch((error) => {
        document.location.href = "join";
      });
      ReactGA.pageview(window.location.pathname + window.location.search);
  }

  nextPage = () => {
    if (this.onload) return;
    this.onload = true;
    setTimeout(() => {
      axios
        .get("/w/api/" + this.pageData.artist.id + "/video?page=" + this.state.page)
        .then((response) => {
          var respData = response.data;
          var newitem = this.state.items.concat(respData.items);
          if (respData.items.length > 0) {
            this.onload = false;
          } else {
            this.finish = true;
          }
          
          this.setState((state) => ({
            page: this.state.page + 1,
            items: newitem,
          }));
          
        });
    }, 200);
  };

  render() {
    return (
      <>
        <CssLoader css={this.pageData.artist.css} />
        <Navbar data={this.pageData} title="VIDEO" />
        {!this.state.title ? (
          <Loading />
        ) : (
          <div className="content video">
            <div className="container">
                {this.pageData.artist.floating_url && (
                    <FloatingButton url={this.pageData.artist.floating_url} />
                )}
              <h4>{this.state.title}</h4>
              <ul className="video-list">
                {utilLoopHelper(this.state.items, (item, index) => {
                  return <VideoList data={item} />;
                })}
              </ul>
              <TrackVisibility>
                {({ isVisible }) => {
                  if (isVisible) this.nextPage();
                  return this.finish ? <></> : <LoadingContent />;
                }}
              </TrackVisibility>
            </div>
          </div>
        )}
        <Footer />
      </>
    );
  }
}

export default VideoPage;
